<template>
	<button
		class="flex h-10 items-center justify-center gap-1.5 truncate rounded-full px-3 text-sm font-medium whitespace-nowrap"
		:class="{
			'bg-fill-primary text-black outline-2 -outline-offset-4 outline-black':
				active,
			'bg-fill-secondary text-label-tertiary shadow-button': !active,
			'opacity-30': disabled && active,
			'*:opacity-30': disabled && !active
		}"
		v-hover="{ impact: 'soft' }"
	>
		<slot />
	</button>
</template>
<script setup lang="ts">
defineProps<{
	active?: boolean
	disabled?: boolean
}>()
</script>
